export const zenDeskScript = (zenDeskToken: string) => `
!(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = 1;
    t.defer = true;
    t.src = a;
    t.id = x;
    t.onload = execCactusEvents('ze-snippet');
    f.parentNode.insertBefore(t, f);
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  'https://static.zdassets.com/ekr/snippet.js?key=${zenDeskToken}',
  "ze-snippet"
  );
`;
